import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLang } from "@/i18n";
import { photos } from "@/data/site";
import { Reveal } from "./Reveal";

export const CtaBanner = () => {
  const { t } = useLang();
  return (
    <section data-testid="final-cta" className="relative overflow-hidden">
      <img src={photos.portaMare} alt="Porta azzurra con bougainvillea sul mare al tramonto" loading="lazy" className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0 bg-mare/60" />
      <div className="relative mx-auto flex min-h-[70vh] max-w-7xl flex-col items-start justify-center px-4 py-24 sm:px-6 lg:px-8">
        <Reveal>
          <h2 className="font-serif text-4xl font-semibold text-sand text-balance sm:text-6xl">{t.finalCta.title}</h2>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-sand/85 sm:text-lg">{t.finalCta.text}</p>
          <Link
            to="/prenota"
            data-testid="final-cta-button"
            className="mt-8 inline-flex items-center gap-2 rounded-full bg-terracotta px-8 py-4 text-base font-bold text-sand shadow-xl shadow-ink/30 transition-all duration-200 hover:bg-terracotta-dark hover:-translate-y-0.5"
          >
            {t.finalCta.cta} <ArrowRight size={18} />
          </Link>
        </Reveal>
      </div>
    </section>
  );
};
